import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { updateCompanyDetails } from '../../api/companyApi';

const CompanyDetailsForm = () => {
  const dispatch = useDispatch();
  const userId = useSelector(state => state.user.data.uid);
  const companyId = useSelector(state => state.user.data?.company_details?.cid);
  const companyDetails = useSelector(state => state.user.data?.company_details); // Assuming you have company details in your Redux store
  const [form] = Form.useForm();

  useEffect(() => {
    if (companyDetails) {
      form.setFieldsValue({
        company_name: companyDetails.company_name,
        website_url: companyDetails.website_url,
      });
    }
  }, [companyDetails, form]);

  const onFinish = (values) => {
    const formData = new FormData();
    Object.keys(values).forEach(key => {
      if (key !== 'logo') {
        formData.append(key, values[key]);
      }
    });
    if (values.logo && values.logo[0] && values.logo[0].originFileObj) {
      formData.append('logo', values.logo[0].originFileObj);
    }
    dispatch(updateCompanyDetails({ userId, companyId, data: formData }));
  };

  return (
      <Row justify={'center'} className={'p-6'}>
        <Col xs={24} lg={12} xxl={8}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              name="company_name"
              label="Company Name"
              rules={[{ required: true, message: 'Please input your company name!' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="website_url"
              label="Website URL"
              rules={[{ required: true, message: 'Please input your website URL!' }]}
            >
              <Input />
            </Form.Item>

            {form.getFieldValue('website_url') && (
              <div style={{ marginBottom: 16 }}>
                <strong>Website Preview:</strong>
                <br />
                <a href={form.getFieldValue('website_url')} target="_blank" rel="noopener noreferrer">
                  {form.getFieldValue('website_url')}
                </a>
              </div>
            )}

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Update Company Details
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
  );
};

export default CompanyDetailsForm;